export const REDIRECT_TO_PORTFOLIO = 'src/Corporate/Home/action/Redirect_To_Portfolio';

export const redirectToPortfolio = (data) => {
    return{
        type: REDIRECT_TO_PORTFOLIO,
        data
    }  
}